/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Article from '../cards/Article';
import CarouselList from '../lists/CarouselList';

import styles from '../../../styles/blocks/suggestion.module.scss';

const propTypes = {
    title: PropTypes.string,
    items: AppPropTypes.listItems,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    items: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

const SuggestionBlock = ({ items, title, className, isContainer, containerClassName }) => {
    if (items === null) return null;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    'blockSuggestion',
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <CarouselList
                    items={items}
                    titleCentered
                    title={title}
                    cardComponent={Article}
                    cardProps={{ isStacked: true }}
                    className={styles.carousel}
                    slotClassName={styles.carouselSlot}
                    cardClassName={styles.carouselCard}
                />
            </div>
        </div>
    );
};

SuggestionBlock.propTypes = propTypes;
SuggestionBlock.defaultProps = defaultProps;

export default SuggestionBlock;
